import React from 'react';
import { AutoPayChangeSuccessComponent } from '../Utils';
import { deleteCookie, getIndivCookie } from 'utils/auth';
import { navigate } from '@reach/router';
import { signout } from '@v10-codeparva/v10-tfw-revamp-package-api';

const navigateTo = (route: string) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    // Keep only the segments up to and including "pay-rent"
    const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
    navigate(`${basePath}/${route}`);
}

export const TenantUpdateSuccessPage = ({ location }: { location: any }) => {
    const {
        state: {
            message
        }
    } = location;
    const cToken = getIndivCookie('cToken');

    const requestBody = {
        token: cToken || '',
        cid: process.env.CID || '',
    }

    const signOutHandler = async () => {
        const signOutResponse = await signout(requestBody);
        const {
            blnSuccess
        } = signOutResponse;
        if (blnSuccess) {
            deleteCookie('cToken');
            navigateTo('tenant-update')
        }
    }

    return <AutoPayChangeSuccessComponent
        message={message}
        logOutHandler={signOutHandler}
    />
};
